import React from 'react';

var GearButton = React.createClass({
	handleClick: function (){
		window.location.href = "?page=Setting";
	},
    render: function(){
      return(
            <button className ="btn__lg bg-white gear--btn tool__tip btn__header" onClick= {this.handleClick}>
              <i className ="fa fa-gear"></i> 
              <strong className ="tool__tip--text">Settings</strong>
            </button>
        );
    }
});

export {GearButton};


/** WEBPACK FOOTER **
 ** ./html/components/GearButton.jsx
 **/